import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { admissionToMeetingType } from "../../../../static/types/commonTypes/admissionToMeetingType";
import AdmissionToMeeting from "./AdmissionToMeeting";
import { initialManagerListState, initialManagerState, } from "../../../../static/types/objectInitialState";
import ComponentsClause from "../crearionSASU/componentsClause";
import { Clause } from "../../../../static/types/clauseTypes/clauseType";
import { CompanyNameType } from "../../../../static/types/commonTypes/companyNameType";
import CompanyName from "../../../commonComponents/CompanyName";
import StatusSignature from "../../../commonComponents/StatusSignature";
import { StatusSignatureType } from "../../../../static/types/commonTypes/statusSignatureType";
import TheSociety from "../../../commonComponents/TheSociety";
import { HeadOfficeAddressType } from "../../../../static/types/commonTypes/headOfficeAddressType";
import HeadOfficeAddress from "../../../commonComponents/HeadOfficeAddress";
import { getCityWithPreposition } from "../../../../utils/functions/getCityWithPreposition";
import { ManagerType } from "../../../../static/types/commonTypes/managerType";
import Manager from "../../../commonComponents/Manager";
import ManagerList from "../../../commonComponents/ManagerList";
import useAppContext from "../../../../hooks/useAppContext";
import { AppContextType } from "../../../../context/AppContext";
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { FaUpload } from 'react-icons/fa';
import { GoArrowRight } from "react-icons/go";
import { useDraftManager } from "../../../../hooks/useDraftManager";
import { formatObjectText } from "../../../../utils/functions/formatObjectText";

interface AnnonceProps {
    txtAnnonce: string;
    updateActiveIndex: (index: number) => void;
    updateTxtAnnonce: (newTxt: string) => void;
    updateDenomination: (newTxt: string) => void;
    societyType: string | string[];
    societeSelected: string;
    updatesocieteSelected: (newTxt: string) => void;
}

const CreationSAS: React.FC<AnnonceProps> = ({
    txtAnnonce,
    updateTxtAnnonce,
    updateActiveIndex,
    updateDenomination,
    societyType,
}) => {

    const {
        companyName, setCompanyName,
        companyNameValidity, setCompanyNameValidity,
        companyNameChecked, setCompanyNameChecked,

        statusSignature, setStatusSignature,
        statusSignatureValidity, setStatusSignatureValidity,
        statusSignatureChecked, setStatusSignatureChecked,

        theSociety, setTheSociety,
        theSocietyValidity, setTheSocietyValidity,
        theSocietyChecked, setTheSocietyChecked,

        headOfficeAddress, setHeadOfficeAddress,
        headOfficeAddressValidity, setHeadOfficeAddressValidity,
        headOfficeAddressChecked, setHeadOfficeAddressChecked,

        admission, setAdmission,
        clause, setClause,

        manager, setManager,
        managerValidity, setManagerValidity,
        managerChecked, setManagerChecked,

        generalManagers, setGeneralManagers,
        generalManagersValidity, setGeneralManagersValidity,
        generalManagersChecked, setGeneralManagersChecked,
        typeGeneralManagersData, setTypeGeneralManagersData,

        executiveOfficers, setExecutiveOfficers,
        executiveOfficersValidity, setExecutiveOfficersValidity,
        executiveOfficersChecked, setExecutiveOfficersChecked,
        typeExecutiveOfficersData, setTypeExecutiveOfficersData,

        statutoryAuditor, setStatutoryAuditor,
        statutoryAuditorValidity, setStatutoryAuditorValidity,
        statutoryAuditorChecked, setStatutoryAuditorChecked,
        typeStatutoryAuditorData, setTypeStatutoryAuditorData,

        alternateAuditor, setAlternateAuditor,
        alternateAuditorValidity, setAlternateAuditorValidity,
        alternateAuditorChecked, setAlternateAuditorChecked,
        typeAlternateAuditorData, setTypeAlternateAuditorData,

        lastTab, setLastTab

    } = useAppContext() as AppContextType

    const { pushDraftContent } = useDraftManager()

    const societyTypeOptions = Array.isArray(societyType) ? societyType : [societyType];
    const [activeTab, setActiveTab] = useState<string>("raisonSociale");
    const [visitedTabs, setVisitedTabs] = useState(["raisonSociale"]);
    const [submissive, setSubmissive] = useState<boolean>(false)

    const goToSupportPresse = () => {
        updateActiveIndex(2);
    };

    const switchTab = (tab: string) => {
setActiveTab(tab);
    };

    const handleSubmit = (e: React.FormEvent) => {

        e.preventDefault();

        if (validate()) {

            const managerText = (manager: ManagerType) => {
                if (manager.person === "Personne morale") {
                    return manager.entityDetails.rcs ? ` ${manager.entityDetails.companyName}, ${manager.entityDetails.legalForm} au capital de ${manager.entityDetails.capital} €, ayant son siège social ${manager.entityDetails.address} ${manager.entityDetails.additionalAddress ?? ""} ${manager.entityDetails.postalCode} ${manager.entityDetails.city}, ${manager.entityDetails.rcs} RCS ${getCityWithPreposition(manager.entityDetails.registrationOffice)}` : ``
                }
                else if (manager.person === "Personne physique") {
                    return manager.personDetails.lastName ? ` ${manager.personDetails.civility === 'Monsieur' ? 'M.' : 'Mme'} ${manager.personDetails.lastName} ${manager.personDetails.firstName}, demeurant ${manager.personDetails.address} ${manager.personDetails.additionalAddress ?? ""} ${manager.personDetails.postalCode} ${manager.personDetails.city}` : ``
                }
            }
            const natureActText = statusSignature.actNature === "acte sous seing privé" ? 'acte SSP' : 'acte authentique'

            const tempText = `Par ${natureActText} du ${statusSignature.actDate},  il a été constitué une ${theSociety.legalForm} ayant les caractéristiques suivantes :
Dénomination : ${companyName.companyName}, ${theSociety.acronym ? `
Sigle: ${theSociety.acronym},` : ``}
Objet social : ${theSociety.object}
Siège social : ${headOfficeAddress.address} ${headOfficeAddress.additionalAddress ?? ""} ${headOfficeAddress.postalCode} ${headOfficeAddress.city},
Capital : ${theSociety.capital} €,
Durée : ${theSociety.duration > 1 ? `${theSociety.duration} ans` : `${theSociety.duration} an`},
Président : ${managerText(manager)}, ${typeGeneralManagersData === 1 ? `
Directeurs Généraux :` : ``} ${generalManagers.map((managerItem: ManagerType, index: number) => managerText(managerItem)).join(" et ")} ${typeExecutiveOfficersData === 1 ? `
Directeurs Généraux Délégués :` : ``} ${executiveOfficers.map((managerItem: ManagerType, index: number) => managerText(managerItem)).join(" et ")} ${typeStatutoryAuditorData === 1 ? `
Commissaires aux comptes ${(typeStatutoryAuditorData === 1 && typeAlternateAuditorData === 0) ? 'Titulaire :' : ''}` : ``} ${typeAlternateAuditorData === 1 ? ` :
-Titulaire : ` : ``}${managerText(statutoryAuditor)} ${typeAlternateAuditorData === 1 ? `
-Suppléant :  ${managerText(alternateAuditor)}.` : ``}
Admission aux assemblée et droits de vote : ${admission.admissionText} ${clause.clause ? `
Clause d'agrément : ${clause.clause}` : ''}
Immatriculation au RCS ${getCityWithPreposition(headOfficeAddress.registrationOffice)}.`

            const formattedText = formatObjectText(tempText);
            updateTxtAnnonce(formattedText);
            updateDenomination(companyName.companyName)
        }
    };

    const validate = () => {
        if (!companyNameValidity) {
            setActiveTab('raisonSociale')
        }
        else if (!statusSignatureValidity) {
            setActiveTab('signatureDesStatus')
        }
        else if (!theSocietyValidity) {
            setActiveTab('laSociété')
        }
        else if (!headOfficeAddressValidity) {
            setActiveTab('adresseDuSiegeSocial')
        }
        else if (!managerValidity) {
            setActiveTab('president')
        }
        else if (typeGeneralManagersData === 1 && !generalManagersValidity) {
            setActiveTab('generalManagers')
        }
        else if (typeExecutiveOfficersData === 1 && !executiveOfficersValidity) {
            setActiveTab('executiveOfficers')
        }
        else if (typeStatutoryAuditorData === 1) {
            if (!statutoryAuditorValidity || (typeAlternateAuditorData === 1 && !alternateAuditorValidity))
                setActiveTab('statutoryAuditor')
        }

        let tempGeneralManagersValidity = typeGeneralManagersData === 0 ? true : generalManagersValidity
        let tempExecutiveOfficersValidity = typeExecutiveOfficersData === 0 ? true : executiveOfficersValidity

        let tempStatutoryAuditorValidity = typeStatutoryAuditorData === 0
            ? true
            : typeAlternateAuditorData === 1
                ? (statusSignatureValidity && alternateAuditorValidity)
                : statutoryAuditorValidity

        return companyNameValidity && statusSignatureValidity && theSocietyValidity && headOfficeAddressValidity && managerValidity && tempGeneralManagersValidity && tempExecutiveOfficersValidity && tempStatutoryAuditorValidity
    };

    const handleNext = () => {

        // Formatage de theSociety (Objet Social)
    const formattedSociety = {
        ...theSociety,
        object: formatObjectText(theSociety.object)
    };
    
    // Utilisez formattedSociety pour mettre à jour les données
    setTheSociety(formattedSociety);

        // Utilisez formattedSociety pour mettre à jour les données
        setTheSociety(formattedSociety);

        if (activeTab === "raisonSociale") {
            setCompanyNameChecked(true);
            if (companyNameValidity) {
                switchTab(getNextTab("raisonSociale"));
            }
        } else if (activeTab === "signatureDesStatus") {
            setStatusSignatureChecked(true);
            if (statusSignatureValidity) {
                switchTab(getNextTab("signatureDesStatus"));
            }
        } else if (activeTab === "laSociété") {
            setTheSocietyChecked(true);
            if (theSocietyValidity) {
                switchTab(getNextTab("laSociété"));
            }
        } else if (activeTab === "adresseDuSiegeSocial") {
            setHeadOfficeAddressChecked(true);
            if (headOfficeAddressValidity) {
                switchTab(getNextTab("adresseDuSiegeSocial"));
            }
        } else if (activeTab === 'admission') {
            switchTab(getNextTab('admission'));
        } else if (activeTab === 'clause') {
            switchTab(getNextTab('clause'))
        } else if (activeTab === 'president') {
            setManagerChecked(true);
            if (managerValidity) {
                switchTab(getNextTab('president'));
            }
        } else if (activeTab === 'generalManagers') {
            setGeneralManagersChecked(true);
            if (typeGeneralManagersData === 1) {
                if (generalManagersValidity) {
                    switchTab(getNextTab('generalManagers'));
                }
            }
            else {
                switchTab(getNextTab('generalManagers'));
            }
        } else if (activeTab === 'executiveOfficers') {
            setExecutiveOfficersChecked(true);
            if (typeExecutiveOfficersData === 1) {
                if (executiveOfficersValidity) {
                    switchTab(getNextTab('executiveOfficers'));
                }
            }
            else {
                switchTab(getNextTab('executiveOfficers'));
            }
        } else if (activeTab === 'statutoryAuditor') {
            setStatutoryAuditorChecked(true);
            if (typeStatutoryAuditorData === 1) {
                if (typeAlternateAuditorData === 1) {
                    setAlternateAuditorChecked(true);
                    if (statutoryAuditorValidity && alternateAuditorValidity) {
                        setSubmissive(true)
                    }
                }
                else if (statutoryAuditorValidity) {
                    setSubmissive(true)
                }
            }
            else {
                setSubmissive(true)
            }
        }
    };

    const handlePrevious = () => {
        switchTab(getPreviousTab(activeTab));
        setSubmissive(false);
    }

    
    useEffect(() => {
        setLastTab(activeTab);
    }, [activeTab]);
    
    useEffect(() => {
        // Si on vient d'un brouillon, restaurer l'onglet actif
        if ( lastTab ) {
            setActiveTab(lastTab);
            // Ajouter tous les onglets précédents comme visités
            const tabOrder = ['raisonSociale', 'signatureDesStatus', 'laSociété', 'adresseDuSiegeSocial', 'admission', 'clause', 'president', 'generalManagers', 'executiveOfficers', 'statutoryAuditor'];
            const currentTabIndex = tabOrder.indexOf(lastTab);
            const visitedTabsArray = tabOrder.slice(0, currentTabIndex + 1);
            setVisitedTabs(visitedTabsArray);
        }
    }, []);    

    const getNextTab = (currentTab: string) => {
        if (currentTab === "raisonSociale") return "signatureDesStatus";
        else if (currentTab === "signatureDesStatus") return "laSociété";
        else if (currentTab === "laSociété") return "adresseDuSiegeSocial";
        else if (currentTab === "adresseDuSiegeSocial") return "admission";
        else if (currentTab === "admission") {
            if (["Société par actions simplifiée", "Société par actions simplifiée à capital variable"].includes(theSociety.legalForm)) return "clause";
            else return "president";
        }
        else if (currentTab === "clause") return "president";
        else if (currentTab === "president") return "generalManagers";
        else if (currentTab === "generalManagers") return "executiveOfficers";
        else if (currentTab === "executiveOfficers") return "statutoryAuditor";
        else return currentTab;
    };

    const getPreviousTab = (currentTab: string) => {

        if (currentTab === "statutoryAuditor") return "executiveOfficers";
        else if (currentTab === "executiveOfficers") return "generalManagers";
        else if (currentTab === "generalManagers") return "president";
        else if (currentTab === "president") {
            if (["Société par actions simplifiée", "Société par actions simplifiée à capital variable"].includes(theSociety.legalForm)) return "clause";
            else return "admission";
        }
        else if (currentTab === "clause") return "admission";
        else if (currentTab === "admission") return "adresseDuSiegeSocial";
        else if (currentTab === "adresseDuSiegeSocial") return "laSociété";
        else if (currentTab === "laSociété") return "signatureDesStatus";
        else if (currentTab === "signatureDesStatus") return "raisonSociale";
        else return currentTab;
    };


    // Raison Social
    const updateCompanyNameValidity = (isValid: boolean) => setCompanyNameValidity(isValid);
    const updateCompanyName = (data: Partial<CompanyNameType>) => setCompanyName({ ...companyName, ...data });

    // Signature of the statutes
    const updateStatusSignatureValidity = (isValid: boolean) => setStatusSignatureValidity(isValid);
    const updateStatusSignature = (data: Partial<StatusSignatureType>) => setStatusSignature({ ...statusSignature, ...data });

    // The Society
    const updateTheSocietyValidity = (isValid: boolean) => setTheSocietyValidity(isValid);

    // Head Office Adress
    const updateHeadOfficeAddressValidity = (isValid: boolean) => setHeadOfficeAddressValidity(isValid);
    const updateHeadOfficeAddress = (data: Partial<HeadOfficeAddressType>) => setHeadOfficeAddress({ ...headOfficeAddress, ...data });

    // Admission to the meeting
    const updateAdmission = (data: Partial<admissionToMeetingType>) => {
        setAdmission((prevAdmission) => ({ ...prevAdmission, ...data }));
    };

    // Clause Agreement
    const updateClause = (data: Partial<Clause>) => {
        setClause((prevClause) => ({ ...prevClause, ...data }));
    };

const tabs = [
  { key: "raisonSociale", label: "Raison Sociale" },
  { key: "signatureDesStatus", label: "Signature des Status" },
  { key: "laSociété", label: "La Société" },
  { key: "adresseDuSiegeSocial", label: "Adresse du Siège Social" },
  { key: "admission", label: "Admission aux assemblées et droits de vote" },
  { key: "president", label: "Le président" },
  { key: "generalManagers", label: "Directeurs généraux" },
  { key: "executiveOfficers", label: "Directeurs généraux délégués" },
  { key: "statutoryAuditor", label: "Commissaire aux comptes" },
];
    return (
        <>
                <div className="container my-3">
                <ul className="nav nav-underline">
                    {tabs
                    .filter((t) => t.key === activeTab) 
                    .map((t) => (
                        <li className="nav-item" key={t.key}>
                        <a
                            href={`#${t.key}`}
                            className={`nav-link active`} 
                        >
                            {t.label}
                        </a>
                        </li>
                    ))}
                        {["Société par actions simplifiée", "Société par actions simplifiée à capital variable"].includes(theSociety.legalForm) && (
                        <li className="nav-item">
                            <a
                            href="#clause"
                            className={`nav-link ${activeTab === "clause" ? "active" : ""}`}
                            onClick={() => switchTab("clause")}
                            >
                            Clause d'agrément
                            </a>
                        </li>
                        )}
                    </ul>
                </div>

            <ToastContainer />

            <form onSubmit={handleSubmit}>
                {
                    activeTab === "raisonSociale" &&
                    <CompanyName
                        changeCompanyName={updateCompanyName}
                        checked={companyNameChecked}
                        companyName={companyName}
                        onValidationChange={updateCompanyNameValidity}
                    />
                }

                {
                    activeTab === "signatureDesStatus" &&
                    <StatusSignature
                        changeStatusSignature={updateStatusSignature}
                        checked={statusSignatureChecked}
                        onValidationChange={updateStatusSignatureValidity}
                        statusSignature={statusSignature}
                    />
                }

                {
                    activeTab === "laSociété" &&
                    <TheSociety
                        checked={theSocietyChecked}
                        companyName={companyName}
                        setTheSociety={setTheSociety}
                        theSociety={theSociety}
                        updateCompanyName={updateCompanyName}
                        updateCompanyNameValidity={updateCompanyNameValidity}
                        updateTheSocietyValidity={updateTheSocietyValidity}
                        societyType={[
                            "Société de Participations Financières de Profession Libérale Société par actions simplifiée",
                            "Société d'exercice libéral par action simplifiée",
                            "Société par actions simplifiée",
                            "Société par actions simplifiée à capital variable"
                        ]}
                    />
                }

                {
                    activeTab === "adresseDuSiegeSocial" &&
                    <HeadOfficeAddress
                        changeHeadOfficeAddress={updateHeadOfficeAddress}
                        checked={headOfficeAddressChecked}
                        headOfficeAddress={headOfficeAddress}
                        onValidationChange={updateHeadOfficeAddressValidity}
                    />
                }

                {
                    activeTab === "admission" &&
                    <AdmissionToMeeting
                        admission={admission}
                        onChange={updateAdmission}
                    />
                }

                {
                    [
                        "Société par actions simplifiée",
                        "Société par actions simplifiée à capital variable"
                    ].includes(theSociety.legalForm) &&
                    activeTab === "clause" &&
                    <ComponentsClause
                        clause={clause}
                        changeClause={updateClause}
                    />
                }

                {
                    activeTab === "president" &&
                    <Manager
                        checked={managerChecked}
                        manager={manager}
                        setChecked={setManagerChecked}
                        setManager={setManager}
                        societyType={societyTypeOptions}
                        updateManagerValidity={(isValid: boolean) => setManagerValidity(isValid)}
                        draftFieldName = "manager"
                    />
                }

                {
                    activeTab === "generalManagers" &&
                    <>
                        <div className="mb-3 row">
                            <strong>
                                Si vous nommez un directeur général différent du président (habilité à engager la société vis à vis des tiers), saisir ses coordonnées.
                            </strong>
                            <label htmlFor="personne" className="col-sm-2 col-form-label">
                                Saisir données
                            </label>
                            <div className="col-sm-10">
                                <select
                                    className="form-select"
                                    id="person"
                                    onChange={(e) => {
                                        setGeneralManagers(initialManagerListState)
                                        setTypeGeneralManagersData(Number(e.target.value))
                                        pushDraftContent({
                                            typeGeneralManagersData: Number(e.target.value ),
                                            generalManagers: initialManagerListState
                                        })
                                    }}
                                    value={typeGeneralManagersData}
                                >
                                    <option value={1}> Oui </option>
                                    <option value={0}> Non </option>
                                </select>
                            </div>
                        </div>
                        {
                            typeGeneralManagersData === 1 &&
                            <ManagerList
                                labelItem=" Directeur général"
                                checked={generalManagersChecked}
                                societyTypeOptions={societyTypeOptions}
                                managers={generalManagers}
                                setManagers={setGeneralManagers}
                                addButtonText="Ajouter un directeur"
                                removeButtonText="Supprimer le dernier directeur"
                                setManagersValidity={(isValid: boolean) => setGeneralManagersValidity(isValid)}
                                draftFieldName = "generalManagers"
                            />
                        }
                    </>
                }

                {
                    activeTab === "executiveOfficers" &&
                    <>
                        <div className="mb-3 row">
                            <strong>
                                Si vous nommez un directeur général délégué, saisir ses coordonnées.
                            </strong>
                            <label htmlFor="personne" className="col-sm-2 col-form-label">
                                Saisir données
                            </label>
                            <div className="col-sm-10">
                                <select
                                    className="form-select"
                                    id="person"
                                    onChange={(e) => {
                                        setExecutiveOfficers(initialManagerListState)
                                        setTypeExecutiveOfficersData(Number(e.target.value))
                                        pushDraftContent({
                                            typeExecutiveOfficersData: Number(e.target.value ),
                                            executiveOfficers: initialManagerListState
                                        })
                                    }}
                                    value={typeExecutiveOfficersData}
                                >
                                    <option value={1}> Oui </option>
                                    <option value={0}> Non </option>
                                </select>
                            </div>
                        </div>
                        {
                            typeExecutiveOfficersData === 1 &&
                            <ManagerList
                                labelItem="Directeur général délégué"
                                checked={executiveOfficersChecked}
                                societyTypeOptions={societyTypeOptions}
                                managers={executiveOfficers}
                                setManagers={setExecutiveOfficers}
                                addButtonText="Ajouter un directeur"
                                removeButtonText="Supprimer le dernier directeur"
                                setManagersValidity={(isValid: boolean) => setExecutiveOfficersValidity(isValid)}
                                draftFieldName = "executiveOfficers"
                            />
                        }
                    </>
                }

                {
                    activeTab === "statutoryAuditor" &&
                    <>
                        <div className="mb-3 row">
                            <strong>
                                Si la société est tenue au regard des dispositions législatives et règlementaires en vigueur de nommer des Commissaires aux comptes, saisir ses coordonnées.
                            </strong>
                            <label htmlFor="commissaire" className="col-sm-2 col-form-label">
                                Saisir données
                            </label>
                            <div className="col-sm-10">
                                <select
                                    className="form-select"
                                    id="commissaire"
                                    onChange={(e) => {
                                        setTypeStatutoryAuditorData(Number(e.target.value))
                                        setSubmissive(false)
                                        setStatutoryAuditor(initialManagerState)
                                        setAlternateAuditor(initialManagerState)
                                        pushDraftContent({
                                            typeStatutoryAuditorData: Number(e.target.value ),
                                            statutoryAuditor: initialManagerState,
                                            alternateAuditor: initialManagerState
                                        })
                                    }}
                                    value={typeStatutoryAuditorData}
                                >
                                    <option value={1}> Oui </option>
                                    <option value={0}> Non </option>
                                </select>
                            </div>
                        </div>
                        {
                            typeStatutoryAuditorData === 1 &&
                            <div className="mb-3 row">
                                <label htmlFor="commissaire" className="col-sm-12 col-form-label">
                                    Commissaire aux comptes
                                </label>
                                <Manager
                                    checked={statutoryAuditorChecked}
                                    manager={statutoryAuditor}
                                    setChecked={setStatutoryAuditorChecked}
                                    setManager={setStatutoryAuditor}
                                    societyType={societyTypeOptions}
                                    updateManagerValidity={(isValid: boolean) => setStatutoryAuditorValidity(isValid)}
                                    draftFieldName = "statutoryAuditor"
                                />

                                <div className="mb-3">
                                    <label htmlFor="commissaire" className="col-sm-12 col-form-label">
                                        Commissaire aux comptes suppléant
                                    </label>
                                    <div className="col-sm-3">
                                        <select
                                            className="form-select"
                                            id="commissaire"
                                            onChange={(e) => {
                                                setAlternateAuditor(initialManagerState)
                                                setTypeAlternateAuditorData(Number(e.target.value))
                                                setSubmissive(false)
                                                pushDraftContent({
                                                    typeAlternateAuditorData: Number(e.target.value ),
                                                    alternateAuditor: initialManagerState
                                                })
                                            }}
                                            value={typeAlternateAuditorData}
                                        >
                                            <option value={1}> Oui </option>
                                            <option value={0}> Non </option>
                                        </select>
                                    </div>
                                </div>

                                {typeAlternateAuditorData === 1 &&
                                    <Manager
                                        checked={alternateAuditorChecked}
                                        manager={alternateAuditor}
                                        setChecked={setAlternateAuditorChecked}
                                        setManager={setAlternateAuditor}
                                        updateManagerValidity={(isValid) => setAlternateAuditorValidity(isValid)}
                                        draftFieldName = "alternateAuditor"
                                    />
                                }
                            </div>

                        }
                    </>

                }

                {
                    activeTab === "statutoryAuditor" &&
                    submissive &&
                    <div className="mt-4">
                        <h4>Texte de l'annonce:</h4>
                        <textarea
                            className="form-control"
                            rows={5}
                            value={txtAnnonce}
                            disabled
                        />
                    </div>
                }

                <div className="button-container">
                    <div className="d-flex gap-2">
                        {
                            activeTab !== "raisonSociale" &&
                            <button
                                color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={handlePrevious}
                            >
                                <SlArrowLeft className="icon" style={{ marginRight: '10px', fontSize: '20px' }} />
                                Modifier mon annonce
                            </button>
                        }
                        {
                            activeTab === "statutoryAuditor" &&
                            <button type="submit"
                                onClick={handleNext}>
                                Mettre à jour mon annonce
                                <FaUpload className="icon" style={{ marginLeft: '15px', fontSize: '20px' }} />
                            </button>
                        }

                        {
                            activeTab !== "statutoryAuditor" &&
                            <button
                                color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={handleNext}>
                                Suivant
                                <SlArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                            </button>
                        }

                        {
                            submissive && activeTab === "statutoryAuditor" &&
                            <button
                                color="#F4A261"
                                className="btn-add"
                                type="button"
                                onClick={goToSupportPresse}
                            >
                                Sélection du support
                                <GoArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                            </button>
                        }
                    </div>
                </div>
            </form>
        </>
    );
};

export default CreationSAS;